export const LOGO_URL = "/images/logo.png";

export const Logo = ({ className = "w-10 h-10" }) => (
  <img src={LOGO_URL} alt="Showtynion" className={`${className} rounded-full object-cover`} data-testid="showty-logo" />
);
